/// \file breadcrumbs.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Breadcrumb, BreadcrumbLinkMouseEvent, DataModel } from "@progress/kendo-react-layout";
import { Fragment } from "react";
import { useMatches, useNavigate, useSubmit } from "react-router-dom";

export interface BreadCrumbDataModel extends DataModel {
  pathname?: string,
  action?: string,
  id?: string
}

const Breadcrumbs: React.FC = () => {
  const navigate = useNavigate();
  const matches = useMatches();
  const submit = useSubmit();

  const crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => {
      if(match.handle) {
        const bc = match.handle as BreadCrumbDataModel;
        if(bc) {
          return true;
        }
      }
      return false;
    } )
    // now map them into an array of elements, passing the loader
    // data to each one
    .map<BreadCrumbDataModel>((match) => {
      if(match.handle) {
        const bc = match.handle as BreadCrumbDataModel;
        let bcText = bc.text;
        if(bcText=="inherit"){
          if(match.pathname){
            bcText=match.pathname.split("/").slice(-1)[0];
          }
        }
        return {
          id: bc.id ?? match.id,
          text: bcText,
          action: bc.action ?? undefined,
          pathname: bc.pathname ?? match.pathname
        };
      }
      return {id: '-1', text: 'No Crumb', pathname: ''};
    });

    const strCustomerCrumbs = localStorage.getItem('customer-crumbs');
  
    if(strCustomerCrumbs) {
      const customerCrumbs = JSON.parse(strCustomerCrumbs) as BreadCrumbDataModel[];
      if(customerCrumbs) {
        crumbs.splice(1,0,...customerCrumbs);
      }
    }

  const handleBreadcrumbItemSelect = (event: BreadcrumbLinkMouseEvent) => {
    const selectedCrumb: BreadCrumbDataModel | undefined = crumbs.find(
      (curValue) => curValue.id === event.id
    );

    //If action exits then perform it, otherwise navigate to pathname
    if(selectedCrumb?.action && selectedCrumb.id) {
      const formData = new FormData();
      formData.append('manage-id', selectedCrumb.id);
      submit(formData, {method: 'post', action: selectedCrumb.action});
    }else if(selectedCrumb?.pathname) {
      navigate(selectedCrumb.pathname);
    } 
  };

  return (
    <Fragment>
      <style>{`
        .k-breadcrumb-link {
          color: #0d6efd;
        }
      `}</style>
      <Breadcrumb
        data={crumbs}
        onItemSelect={handleBreadcrumbItemSelect}
        //this is added to mimic the pierce site
        style={{
          background: '#ea1215',
          color: 'white'
        }}


      />
    </Fragment>
  );
}

export default Breadcrumbs;